import tokens from '../tokens'

import common from './common'
import { Theme } from './types'

const themeColors = {
  // Theme base
  primary: tokens.colors.hullOrange6,
  primaryDark: tokens.colors.hullOrange9,
  primaryLight: tokens.colors.hullOrange0,

  // Emphasis
  highestEmphasis: 'rgba(0, 0, 0, 1.0)',
  higherEmphasis: 'rgba(0, 0, 0, 0.92)',
  highEmphasis: 'rgba(0, 0, 0, 0.64)',
  mediumEmphasis: 'rgba(0, 0, 0, 0.52)',
  lowEmphasis: 'rgba(0, 0, 0, 0.4)',
  lowerEmphasis: 'rgba(0, 0, 0, 0.12)',
  lowestEmphasis: 'rgba(0, 0, 0, 0.04)',

  // Components
  avatarBackground: tokens.colors.hullOrange0,
  avatarBorder: tokens.colors.hullOrange9,
  avatarText: tokens.colors.hullOrange9,
  borderColor: tokens.colors.hullOrange9,
  dividerBackground: tokens.colors.hullOrange0,
  hoverBackground: tokens.colors.hullOrange0,
  selection: tokens.colors.nebulaBlue0,
  textActive: tokens.colors.hullOrange,
  textLink: tokens.colors.hullOrange,
}

const components = {
  calendar: {
    textColor: 'mediumEmphasis',
    todayTextColor: 'primaryDark',
    todayHoverShadowColor: 'primary',
    outsideTextColor: 'lowerEmphasis',
    hoverColor: 'lowerEmphasis',
    hoverShadowColor: 'highEmphasis',
    selectedColor: tokens.colors.hullOrange2,
    selectedTextColor: 'mediumEmphasis',
    selectedHoverShadowColor: 'highEmphasis',
    rangeCapTextColor: tokens.colors.hullOrange4,
    focusBorderColor: tokens.colors.hullOrange8,
  },
  button: {
    color: '#FFFFFF',
  },
  text: {
    color: 'mediumEmphasis',
  },
}

export default {
  name: Theme.home,
  ...tokens,
  colors: {
    ...tokens.colors,
    ...common.colors,
    ...themeColors,
  },
  components,
}
